import React from 'react';
import styles from "../../OfferForm.module.css";
import {OfferFormSelectionProvider, OfferRequest, OfferRequestPartial} from "../../OfferForm";
import {useAppSelector} from "../../../../../../../app/hooks";
import {ValidationResult} from "../../../../../../elements/validator/component/ValidationComponent";
import {DiscountInputField} from "../../../../../../elements/discountInputField/DiscountInputField";

interface Props<T extends OfferRequest> {
    getMessage: (s: any) => any;
    updateRequest: (update: OfferRequestPartial) => void;
    selectionProvider: OfferFormSelectionProvider;
    updateValidationStatus: (status: ValidationResult<T>) => void,
}

export const OfferWithDiscountFields = <T extends OfferRequest>({
                                                                    getMessage,
                                                                    updateRequest,
                                                                    selectionProvider,
                                                                    updateValidationStatus
                                                                }: Props<T>) => {

    const discount = useAppSelector(selectionProvider.discount)

    const handleUpdateSubtractionValue = (v: any) => {
        updateRequest({discount: {id: discount?.id, subtractionValue: v, subtractionType: discount!.subtractionType}})
    }

    const handleUpdateType = (v: any) => {
        updateRequest({discount: {id: discount?.id, subtractionValue: discount!.subtractionValue, subtractionType: v}})
    }

    return <div className={styles.fieldsLine}>
        <DiscountInputField
            type={"number"}
            value={discount!.subtractionValue}
            setValue={handleUpdateSubtractionValue}
            subtractionType={discount!.subtractionType}
            onSubtractionChange={handleUpdateType}
            errorMessage={getMessage("discount")}
        />
    </div>
}
